<template>

	<modal-dialog
		:modal-visible="modalVisible"
		title="Edit Image"
		modal-size="modal-full"
		cancel-button-text="Done"
		v-on:confirm="saveImage"
		v-on:closeModal="$emit('closeModal')">

		<div class="row">
			<div class="col-xl-3">

				<div v-if="layers && layers.length > 0" class="card layers-card mb-2" style="overflow: hidden;">
					<div class="card-header">Layers</div>

					<ul class="list-group layers-list">
						<li v-for="(layer,index) in layers" class="list-group-item d-flex justify-content-between align-items-center">
							<label>
								<input type="checkbox" class="btn btn-light btn-sm mr-2" v-on:click="toggleLayerVisibility(index)" v-model="visibilityLayers[index]">
								<i
									class="fa fa-fw"
									:class="{
										'fa-eye' : visibilityLayers[index],
										'fa-eye-slash' : !visibilityLayers[index]
									}"
									style="position: relative;top: 5px;">
								</i>
							</label>
							<span>Layer {{ index + 1 }}</span>
							<div>

								<button type="button" class="btn btn-danger btn-sm ml-1" v-on:click="deleteLayer(index)">
									<i class="fa fa-trash"></i>
									Delete
								</button>
							</div>
						</li>

					</ul>
				</div>

				<div class="card drawing-card mb-4 p-0">

					<div class="card-header">Drawing</div>

					<div class="card-body">

						<div class="d-flex justify-content-between align-items-center flex-wrap">

							<field
								:params="{
									type: 'color-picker',
									colors: [
										'#000000',	// Black
										'#ffffff',	// White
										'#ff0000',	// Red
										'#ffbc00',	// Yellow/Orange
										'#2000df',	// Blue
										'#40b100'	// Green
									],
									hideDeselect: true
								}"
								v-model="strokeColor">
							</field>

							<field
								:params="{
									type:'native-select',
									options: [
										{ text: 'Very Thin',  value: 1 },
										{ text: 'Thin',       value: 3 },
										{ text: 'Medium',     value: 10 },
										{ text: 'Thick',      value: 20 },
										{ text: 'Very Thick', value: 40 },
									]}"
								v-model="strokeThickness">
							</field>

						</div>

					</div>


				</div>
			</div>
			<div class="col-xl-9">
				<div class="d-flex justify-content-center">

					<div ref="canvasParent" class="canvas-parent">

						<image-with-layers
							:image-url="imageUrl"
							:layers="filteredLayers"
							:rerender-trigger="rerenderCount"
							v-on:init="imageInitialized">
						</image-with-layers>

						<div class="draw-canvas">
							<canvas
								ref="drawCanvas"
								id="drawCanvas"
								:style="canvasStyle">
							</canvas>
						</div>

					</div>

				</div>
			</div>
		</div>

		

	</modal-dialog>

</template>

<script>

import ModalDialog from "@/components/ModalDialog";
import Field from "@/components/Field";
import ImageWithLayers from "@/components/ImageWithLayers";

export default {
	name: "EditImageModal",
	props: [
		"modalVisible",  // is the edit modal visible?
		"imageUrl",      // url of original image
		"layers",         // layers to render on original image
	],
	components: {
		ModalDialog,
		Field,
		ImageWithLayers
	},
	mixins: [
		
	],
	data() {
		return {

			image: null,            // image at imageUrl
			drawCanvas: null,
			rect: null,
			context: null,

			canvasWidth: 100,       // Width of canvas
			canvasHeight: 100,      // Height of canvas

			strokeColor: '#000000', // Selected color
			strokeThickness: 10, // Selected thickness

			selectedLayer: -1,
			visibilityLayers: [],

			capturingMouse: false,
			lastPosition: {},
			mouseX: 0,
			mouseY: 0,
			drawingTrail: [],
			drawLayer: {
				strokes: [],
				canvasWidth: null
			},
			rerenderCount: 1
		}
	},
	watch: {

		modalVisible() {
			if (this.modalVisible) {
				this.$store.isUserDrawing = true

				if (!document.fullscreenElement) 
					document.documentElement.requestFullscreen();

				this.initDrawingCanvas()
				
				
			} else {
				this.$store.isUserDrawing = false

				if (document.exitFullscreen) 
					document.exitFullscreen();
				
			}

			this.rerenderCount++

			if (window.innerWidth < this.mobileBreakpoint)
				this.toggleFullScreen()
		},
		
		imageUrl() {
			if (this.modalVisible) {
				this.initDrawingCanvas()
				this.rerenderCount++
			}
		},

		layers() {
			if (this.modalVisible) {
				this.initDrawingCanvas()
				
				
				this.visibilityLayers = []
				this.layers.forEach(layer => {
					this.visibilityLayers.push(true)
				})


				//console.log(vm.hiddenLayers)

				this.rerenderCount++

			}
		}

	},
	computed: {

		canvasStyle() {
			return {
				width: this.canvasWidth+'px', 
				height: this.canvasHeight+'px',
				zIndex: 50
			}
		},

		filteredLayers() {
			let filtered = []

			let vm = this
			if (this.layers) {
				filtered = this.layers.filter((layer,index) => {
					if (this.visibilityLayers[index])
						return true

					return false
				})

				return filtered
			}
			else return []
		}

	},
	methods: {
		imageInitialized(values) {
			//this will include the imageTag dimensions, so we need to match the draw canvas size with that
			
			// We need the canvasParent ref in order to run this
			if (!this.$refs.canvasParent) {
				console.log("canvasParent not found")
				return
			}

			if (!this.$refs.drawCanvas) {
				console.log("drawCanvas not found")
				return
			}

			let drawCanvas = this.$refs.drawCanvas

			this.canvasWidth = values.dimensions.width
			this.canvasHeight = values.dimensions.height

			this.initDrawingCanvas()

		},
		initDrawingCanvas() {

			let vm = this

			setTimeout(() => {

				vm.$nextTick(() => {

					if (!vm.$refs.canvasParent) {
						console.log("canvasParent not found")
						return
					}

					if (!vm.$refs.drawCanvas) {
						console.log("drawCanvas not found")
						return
					}

					vm.drawCanvas = vm.$refs.drawCanvas
					vm.rect = vm.drawCanvas.getBoundingClientRect()
					vm.context = vm.drawCanvas.getContext("2d");

					vm.context.clearRect(0, 0, vm.drawCanvas.width, vm.drawCanvas.height);
					
					//vm.removeEventListeners()

					vm.addEventListeners(vm.drawCanvas)

					// Set tab
					vm.editType = 'arrange'

					// Reset pen values
					vm.strokeColor = '#000000'
					vm.strokeThickness = 10

					vm.drawLayer.strokes = []

					vm.drawCanvas.width = vm.canvasWidth
					vm.drawCanvas.height = vm.canvasHeight

					vm.drawLayer.canvasWidth = vm.canvasWidth
				})

			},300)

		},
		addEventListeners(canvas) {
			let vm = this

			canvas.addEventListener("touchstart",vm.touchDown,false)
			canvas.addEventListener("touchend",vm.touchUp,false)
			canvas.addEventListener("touchmove",vm.touchMove,false)
			canvas.addEventListener("mousedown",vm.mouseDown,false)
			canvas.addEventListener("mousemove",vm.mouseMove,false)
			
			document.body.addEventListener("mouseup", vm.mouseUp, false);
			document.body.addEventListener("touchcancel", vm.touchUp, false);
		},
		removeEventListeners() {
			let vm = this

			vm.drawCanvas = vm.$refs.drawCanvas

			if (vm.drawCanvas) {
				vm.drawCanvas.removeEventListener("touchstart",vm.mouseDown)
				vm.drawCanvas.removeEventListener("touchend",vm.mouseUp)
				vm.drawCanvas.removeEventListener("touchmove",vm.touchMove)
				vm.drawCanvas.removeEventListener("mousedown",vm.mouseUp)
				vm.drawCanvas.removeEventListener("mousemove",vm.mouseMove)
			}

			document.body.removeEventListener("mouseup", vm.mouseUp, false);
			document.body.removeEventListener("touchcancel", vm.touchUp, false);
		},
		mouseDown() {
			this.capturingMouse = true

			this.rect = this.drawCanvas.getBoundingClientRect()
			this.context = this.drawCanvas.getContext("2d");

			this.context.lineWidth = this.strokeThickness
			this.context.strokeStyle = this.strokeColor
			this.context.lineCap = "round"
		},
		touchDown() {
			this.mouseDown()
		},
		mouseMove(event) {
			//draw trail
			if (this.capturingMouse) 
				this.drawTrail(event.clientX,event.clientY)
		},
		touchMove(e) {
			e.preventDefault()

			if (this.capturingMouse)
				this.drawTrail(e.targetTouches[0].clientX,e.targetTouches[0].clientY)
		},
		drawTrail(x,y) {
			let vm = this

			this.drawCanvas = this.$refs.drawCanvas

			if (this.drawCanvas) {
				
				//draw trail
				if (this.capturingMouse) {

					let position = {
						x: (x - this.rect.left),
						y: (y - this.rect.top)
					}

					if ("x" in this.lastPosition) {
						this.context.beginPath()
						this.context.moveTo(this.lastPosition.x, this.lastPosition.y)
						this.context.lineTo(position.x, position.y)

						this.context.stroke()
					}

					this.lastPosition = position

					this.drawingTrail.push(position)
				}
			}
		},
		mouseUp() {
			if (this.capturingMouse) {
				this.capturingMouse = false

				this.lastPosition = {}
				this.drawingTrail.push({})

				this.drawLayer.strokes.push({
					trail: this.drawingTrail,
					strokeColor: this.strokeColor,
					strokeThickness: this.strokeThickness
				})

				this.drawingTrail = []
			}
		},
		touchUp() {
			this.mouseUp()
		},
		deleteLayer(index) {
			let layerId = this.layers[index].id

			this.$emit("deleteLayer",layerId)
		},
		saveImage() {
			this.$emit('saveLayer', this.drawLayer)

		},
		toggleLayerVisibility(index) {
			this.visibilityLayers[index] = !this.visibilityLayers[index]
			this.rerenderCount++

			this.$forceUpdate()
		},
	},
	created() {
		this.initDrawingCanvas()

		let vm = this

		//default layers to all visible
		vm.visibilityLayers = []
		if (vm.layers) {
			vm.layers.forEach(layer => {
				vm.visibilityLayers.push(true)
			})
		}
		
		vm.$forceUpdate()

		setTimeout(() => {
			vm.rerenderCount++
		},30)
	},
	destroyed() {
		this.removeEventListeners()
	}
}
</script>

<style type="text/css" scoped>

.layers-card .card-header,
.drawing-card .card-header {
	padding-top: 3px;
	padding-bottom: 3px;
	padding-left: 10px;
}

.layers-list {
	margin: -1px;
	margin-top: 0;
}

.layers-list .list-group-item {
	padding-top: 5px;
	padding-bottom: 5px;
}

.canvas-parent {
	width: 100%;
	position: relative;
}

.draw-canvas {
	position: absolute;
	top: 0;
	left: 0;
}

.draw-canvas canvas {
	box-shadow: inset 0 0 4px #efefef;
	border: 1px solid #ced4da;
	display: block;
	cursor: crosshair;
	z-index: 50;
	position: relative;
}
</style>